import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SchemaOrg from '@/components/feature/SchemaOrg';
import Hero from './components/Hero';
import CategorySection from './components/CategorySection';
import FeaturedContent from './components/FeaturedContent';
import LatestContent from './components/LatestContent';
import WhyChooseUs from './components/WhyChooseUs';
import FAQ from './components/FAQ';
import { siteInfo, faqs } from '@/mocks/site';

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const webSiteSchema = {
    name: siteInfo.name,
    url: 'https://www.91pian.com',
    description: siteInfo.description,
    inLanguage: 'zh-CN',
  };

  const organizationSchema = {
    name: siteInfo.name,
    url: 'https://www.91pian.com',
    description: siteInfo.description,
    email: siteInfo.email,
    telephone: siteInfo.phone,
    address: {
      '@type': 'PostalAddress',
      streetAddress: '建国路88号SOHO现代城A座',
      addressLocality: '北京',
      addressRegion: '朝阳区',
      addressCountry: 'CN',
    },
  };

  const webPageSchema = {
    name: '91片官方首页',
    description: siteInfo.description,
    url: 'https://www.91pian.com',
    inLanguage: 'zh-CN',
    isPartOf: { '@type': 'WebSite', name: siteInfo.name, url: 'https://www.91pian.com' },
  };

  const faqSchema = {
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <>
      <SchemaOrg type="WebSite" data={webSiteSchema} />
      <SchemaOrg type="Organization" data={organizationSchema} />
      <SchemaOrg type="WebPage" data={webPageSchema} />
      <SchemaOrg type="FAQPage" data={faqSchema} />

      <Navbar />
      <main>
        <Hero />
        <CategorySection />
        <FeaturedContent />
        <LatestContent />
        <WhyChooseUs />
        <FAQ />
      </main>
      <Footer />
    </>
  );
}